import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, InputGroup, Form, FormControl, Button } from 'react-bootstrap';
import React, { useEffect, useState } from "react";
import { Get, getDataToday, getProducers, getReceptions, getReceptionsByDates, getReceptionsByIds } from '../helpers/AxiosHelper';
import { componentDidMount } from '../helpers/AuthContext';
import "./Reception.css"
import { PaginatedItems } from './table';

const Reception = () => {    
    const [producers, setProducers] = useState([]);
    const [showProducers, setShowProducers] = useState(false);
    const [dataTable, setDataTable] = useState(null);
    const [showDataTable, setShowDataTable] = useState(false);

    const url = "http://api.coexca.cl/api/usuario?email=" + sessionStorage.getItem("userName");

    let data;

    useEffect(()=>{
        componentDidMount("Recepciones");
        if(sessionStorage.getItem("accessToken")){
            Get(url, 'Home');
            (async () =>{
                const data = await getProducers();
                setProducers(data);
                setShowProducers(true);
                const dataTable = await getDataToday(sessionStorage.getItem("favorite"));
                setDataTable(dataTable);
                setShowDataTable(true);
            })();
        }
        let yourDate = formatDate();
        document.getElementById("date1").setAttribute("max", yourDate);
        document.getElementById("date2").setAttribute("max", yourDate);
    }, [])

    function formatDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }
      
    function renderProducers(){
        return (
            <Form.Select id="producer" defaultValue={sessionStorage.getItem("favorite")} name='producer' aria-label="Default select example">
                {
                    producers.map((producer) => {
                        if(producer.id == sessionStorage.getItem("favorite")){
                            return(
                                <option key={producer.id} value={producer.id} defaultValue>{producer.nombre}</option>
                            )
                        }else{
                            return(
                                <option key={producer.id} value={producer.id}>{producer.nombre}</option>
                            )
                        }
                    })
                }
            </Form.Select>
        )
    }

    async function getDataTable(event){
        event.preventDefault();
        setShowDataTable(false);

        const producer  = event.target.producer.value;
        const dayFrom   = event.target.selectDayFrom.value;
        const dayTo     = event.target.selectDayTo.value;
        const receptionFrom = event.target.reception1.value;
        const receptionTo = event.target.reception2.value;
        const itsChecked = event.target.checkReception.checked;

        if(dayFrom != "" && dayTo != "" ){
            if(receptionFrom != "" && itsChecked){
                data = await getReceptions(producer, dayFrom, dayTo, receptionFrom, receptionTo, "To");
                setDataTable(data);
                setShowDataTable(true);
            }else if(receptionFrom != ""){
                data = await getReceptions(producer, dayFrom, dayTo, receptionFrom, receptionTo, "From");
                setDataTable(data);
                setShowDataTable(true);
            }else{
                data = await getReceptionsByDates(producer, dayFrom, dayTo, receptionFrom, receptionTo);
                setDataTable(data);
                setShowDataTable(true);
            }
        }else if(receptionFrom != "" || receptionTo != ""){
            if(receptionTo != "" && itsChecked){
                data = await getReceptionsByIds(producer, receptionFrom, receptionTo, itsChecked);
                setDataTable(data);
                setShowDataTable(true);
            }else if(receptionFrom != ""){
                data = await getReceptionsByIds(producer, receptionFrom, receptionTo, itsChecked);
                await setDataTable(data);
                setShowDataTable(true);
            }
        }else{
                data =  await getReceptions(producer, dayFrom, dayTo, receptionFrom, receptionTo, "Date");
        }

    }

    /* Funcion que se ejecuta al cambiar el valor del checkbox */
    const handleChange = (event) =>{
        if(event.target.checked){
            document.getElementById("receptionTo").style.visibility= "visible";
            document.getElementById("reception2").style.visibility= "visible";
            document.getElementById("reception1From").style.display= "block";
        }else{
            document.getElementById("receptionTo").style.visibility= "hidden";
            document.getElementById("reception2").style.visibility= "hidden";
            document.getElementById("reception1From").style.display= "none";
        }
    }

    const onChangeFrom = (event) =>{
        document.getElementById("date2").setAttribute("min", event.target.value);
    }

    const onChangeTo = (event) =>{
        document.getElementById("date1").setAttribute("max", event.target.value);
    }
    
    return (
        <>
            <div className='searchReceptions'>
                <Form onSubmit={getDataTable}>
                    <Row>
                        <p></p>
                        <h2>Búsqueda de Recepciones</h2>
                        <p></p>
                    </Row>
                    <Row>
                        <Col xs={1}></Col>
                        <Col xs={5} className='colReceptions'>
                            <b>Productor</b>
                            {showProducers ? renderProducers() : <React.Fragment/>}
                        </Col>
                        <Col xs={5} className='colReceptions'>
                            <b>Fecha:</b>
                            <InputGroup className="mb-3">
                                <InputGroup.Text>Desde:</InputGroup.Text>
                                <FormControl id="date1" name="selectDayFrom" type="date" aria-describedby="basic-addon3" onChange={onChangeFrom}/>

                                <InputGroup.Text>Hasta:  </InputGroup.Text>
                                <FormControl id="date2" name="selectDayTo" type="date" aria-describedby="basic-addon3" onChange={onChangeTo}/>
                            </InputGroup>
                        </Col>
                        <Col xs={1}></Col>
                    </Row>
                    <Row>
                        <Col className='col-1'></Col>
                        <Col className='colReceptions col-4'>
                            <b>Recepción:</b>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="reception1From">Desde: </InputGroup.Text>
                                <FormControl id="reception1" name="reception1" placeholder="Id recepción" type="number" aria-describedby="basic-addon3" />
                                <InputGroup.Text id="receptionTo">Hasta: </InputGroup.Text>
                                <FormControl id="reception2" name="reception2" placeholder="Id recepción" type="number" aria-describedby="basic-addon3" />
                            </InputGroup>
                        </Col>
                        <Col className='colReceptions col-2'>
                            <h5 style={{visibility: "hidden"}}>R</h5>
                            <InputGroup className="mb-4">
                                    <Form.Check defaultChecked name='checkReception' id='checkReception' type='checkbox' label='Rango de Recepciones' onClick={handleChange}/>
                            </InputGroup>
                        </Col>
                        <Col className='col-2'>
                            <h5 style={{visibility: "hidden"}}>R</h5>
                            <InputGroup>
                                <Button type='submit' variant='primary'>Aplicar Filtros</Button>
                            </InputGroup></Col>
                    </Row>
                </Form>
                <br></br>
                
                {showDataTable ? <PaginatedItems data={dataTable}></PaginatedItems> : <React.Fragment/>}
            </div>
        </>
    )
}

export default Reception